// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  trustworthiness: __t.i32(),
  creatorRatingX100: __t.i32().name("creator_rating_x_100"),
  ratingCount: __t.u32().name("rating_count"),
  socialCapital: __t.i32().name("social_capital"),
  notoriety: __t.i32(),
  traitorUntil: __t.timestamp().name("traitor_until"),
});
